import { useCallback } from "react";

import { useEditorState } from "@tiptap/react";

import { editorPopoverKey } from "./EditorPopover";

import type { EditorPopoverRender, EditorPopoverState } from "./EditorPopover";
import type { Editor } from "@tiptap/react";

type UseEditorPopover = {
  isOpen: boolean;
  state: EditorPopoverState | undefined;
  open: (render: EditorPopoverRender) => void;
  close: () => void;
};

export function useEditorPopover(editor?: Editor | null): UseEditorPopover {
  const state = useEditorState({
    editor: editor ?? null,
    selector: () => (editor ? editorPopoverKey.getState(editor.state) : null),
  });

  const open = useCallback(
    (render: EditorPopoverRender) => {
      editor?.commands.openPopover(render);
    },
    [editor],
  );

  const close = useCallback(() => {
    editor?.commands.closePopover();
  }, [editor]);

  return {
    isOpen: !!state,
    state,
    open,
    close,
  };
}
